export const PLAYER_SEAT_NAMES = ['South', 'East', 'North', 'West'] as const;

export type PlayerSeatName = (typeof PLAYER_SEAT_NAMES)[number];

const LEGACY_DEFAULT_NAME = /^(?:AI )?Player [1-4]$/;

export function getPlayerSeatName(playerId: number): PlayerSeatName {
  const seatName = PLAYER_SEAT_NAMES[playerId];
  if (!seatName) {
    throw new RangeError(`Invalid player seat: ${playerId}`);
  }
  return seatName;
}

export function getPlayerDisplayName(playerId: number, name?: string): string {
  if (!name || LEGACY_DEFAULT_NAME.test(name)) {
    return getPlayerSeatName(playerId);
  }
  return name;
}
